import { z } from 'zod';

const WEIGHT_ANALYSIS = {
  label: 'Lens Weight', group: 'system',
  description: 'Element weights and centers of mass.',
  settingsSchema: z.strictObject({}), parameters: [],
  coverage: 'Uses the lens materials, edges, chamfers and mirror backing. Mounts and spacers are not included. A mirror needs a backing definition to have weight, so a zero mirror weight does not mean the mirror is massless. Total weight is in grams; CODE V does not state the units of volume or center of mass.',
} as const;
export default WEIGHT_ANALYSIS;
